import {Component, OnInit} from '@angular/core';
import {ActionTypeEnum} from '../../../constants/action-type.enum';
import {UserService} from '../../../services/user.service';
import {SachetStockService} from '../../../services/sachet-stock.service';
import {UnapModel} from '../../../model/unap.model';
import {UnapService} from '../../../services/unap.service';
import {ProvinceService} from '../../../services/province.service';
import {CountyService} from '../../../services/county.service';
import {ProvinceModel} from '../../../model/province.model';
import {CountyModel} from '../../../model/county.model';
import {SachetStock} from '../../../model/sachet-stock.model';

@Component({
    selector: 'sachets-organizations',
    templateUrl: './sachets-organizations.component.html',
    styleUrls: ['./sachets-organizations.component.scss']
})
export class SachetsOrganizationsComponent implements OnInit {

    searchTerm: string;
    searching: boolean = false;
    currentPage = 0;
    totalPages = 0;
    pages = [];
    hitsPerPage = 20;
    pageSize = 20;
    result = [];
    totalResult = 0;
    totalUsers = 0;
    paginationTotal: number = 0;
    countyFilter: CountyModel;
    provinceFilter: ProvinceModel;
    provinces: ProvinceModel[] = [];
    counties: CountyModel[] = [];
    unapStock: SachetStock;
    configs: any = {};

    unaps: UnapModel[];

    constructor(private userService: UserService,
                private unapService: UnapService,
                private provinceService: ProvinceService,
                private countyService: CountyService,
                private sachetService: SachetStockService) {
    }

    get user() {
        return this.userService.getLocalStorageUser();
    }

    getClass(counter: number, actionType?: string) {
        if (actionType) {
            return 'black';
        }
        if (counter < 0) {
            return 'negative';
        } else {
            return 'positive';
        }
    }

    getCounterLabel(counter: number, actionType?: string) {
        if (actionType === ActionTypeEnum.EDITED_STOCK) {
            return counter;
        }
        if (counter < 0) {
            return counter;
        } else {
            return `+${counter}`;

        }
    }

    getSachetInformation(unap: UnapModel) {
        if (unap.id === 615) {
            if (this.configs?.red?.UNAP >= this.unapStock?.redCount ||
                this.configs?.yellow?.UNAP >= this.unapStock?.yellowCount) {
                return 'Stock Bajo';
            }
        }

        return 'Stock Normal';
    }

    getRedSachetsCount(unap: UnapModel) {
        if (615 !== unap.id) {
            return 0;
        }
        return this.unapStock?.redCount;
    }

    getYellowSachetsCount(unap: UnapModel) {
        if (615 !== unap.id) {
            return 0;
        }
        return this.unapStock?.yellowCount;
    }

    filterByName() {
        this.unaps = this.unaps.filter(unap =>
            unap.name.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
    }

    filterCounties() {
        this.counties = this.countyService.listByProvince(this.provinceFilter);
    }

    clearFiltersByName() {
        this.searchTerm = null;
        this.unapService.findAll().subscribe(result => {
            this.unaps = result;
        });
    }

    searchByProvinceCounty() {
        this.unaps = this.unaps.filter(unap1 =>
            unap1.provinceReference == this.provinceFilter.id.toString() && unap1.countyReference === this.countyFilter.id.toString());
    }

    loadSachetStockByOrganizationId(id: number) {
        if (id == 615) {
            const key = `sachets-stock-${id}`;
            this.sachetService.findStockByOrganizationCode(key).subscribe(stock => {
                this.unapStock = stock;
            });
        }
    }


    ngOnInit(): void {
        this.unapService.findAll().subscribe(result => {
            this.unaps = result;
        });

        this.sachetService.findStockByOrganizationCode('sachets-stock-' + 615).subscribe(stock => {
            this.unapStock = stock;
        });

        this.sachetService.getSachetsConfig().subscribe(config => {
            this.configs = config;
            console.log(this.configs);
        });


        // this.provinces = this.provinceService.listAll();
    }

}
